import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

// Array of experience objects for easy editing and scalability
const experiences = [
  {
    title: "DevOps / IT Engineer",
    date: "07/2024 to Current",
    company: "Supply Chain Illuminations – Remote",
    bullets: [
      "Design and implement CI/CD pipelines to streamline deployment processes, automate provisioning, and manage infrastructure as code (IaC) for cloud and on-prem environments.",
      "Continuously monitor application performance, troubleshoot issues, and ensure high availability, scalability, and security of systems through proactive incident management.",
      "Work closely with development teams to integrate their code into production environments, ensuring smooth collaboration between developers and system administrators.",
      "Implement best practices for security, including vulnerability assessments, system hardening, and ensuring compliance with regulatory standards, while managing backups, disaster recovery, and data integrity processes."
    ]
  },
  {
    title: "Data Science Analyst",
    date: "02/2023 to 03/2024",
    company: "Trakr Ai – Remote",
    bullets: [
      "Manage company cloud services saving over 40% cost from previous months to use maximum amount of computing power and saving cost limiting waste.",
      "Worked with external engineering team to develop our product. Managed sprints week and fixed roadblocks to make impact on our delivery.",
      "Collaborated with cross-functional teams to optimize business processes using data insights.",
      "Assisted in development of comprehensive data strategy, aligning analytics efforts with organizational goals.",
      "Contributed to continuous improvement of internal processes by proactively identifying areas where analytics could add value or streamline workflows."
    ]
  },
  {
    title: "Data Analyst",
    date: "08/2022 to 02/2023",
    company: "USA Rare Earth – Tampa, FL",
    bullets: [
      "Accomplished building data relationship website to help view analysis of multiple companies with over 22000 entities. Clean over 90% of data stored in it.",
      "Made it more user-friendly for non-technical employees that helped the use of the software company wide.",
      "Worked with stakeholder to develop a large analytics tool that would help them make decisions.",
      "Identified, analyzed, and interpreted trends or patterns in complex data sets by finding correlations and visualizing them with charts.",
      "Completed data cleaning and data validation of existing spreadsheets to promote robust data management platform, resulting in accurate data analysis and entry."
    ]
  },
  {
    title: "Store Manager",
    date: "03/2016 to Current",
    company: "Gios Cuban Cafe – Tampa, Florida",
    bullets: [
      "Managed opening and closing procedures and recommended changes to enhance efficiency of daily activities.",
      "Maintained positive customer relationships by responding quickly to customer service inquiries."
    ]
  },
  {
    title: "Service Advocate",
    date: "12/2023 to 07/2024",
    company: "Target – Tampa, Florida",
    bullets: [
      "Alternated goods in inventory by observing first-in and first-out approach to keep shelves organized and properly stocked.",
      "Assisted over 100 customer daily by locating items, processing payments and carrying out heavy purchases."
    ]
  }
];

const Experience = () => {
  return (
    <Box id="experience" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <Typography variant="h2" gutterBottom>
          Experience
        </Typography>
        {experiences.map((exp, idx) => (
          <Paper
            key={idx}
            sx={{
              p: 3,
              mb: 3,
              borderRadius: 4,
              backgroundColor: '#1976d2',
              color: '#fff',
              boxShadow: 3,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {exp.title}, <span style={{ fontWeight: 'normal' }}>{exp.date}</span>
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              {exp.company}
            </Typography>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
              {exp.bullets.map((bullet, i) => (
                <li key={i}>
                  <Typography variant="body1">{bullet}</Typography>
                </li>
              ))}
            </ul>
          </Paper>
        ))}
      </Container>
    </Box>
  );
};

export default Experience;